import React, { useState } from "react";

import { navigate } from "gatsby";
import "./ContactUs.css";

const ContactUs = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const handleSubmit = (evt) => {
    evt.preventDefault();
    var xhr = new XMLHttpRequest();
    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/8753452/d27f8469-18ae-45d0-9d18-04da86d89c51";
    var data = {
      fields: [
        {
          name: "email",
          value: email,
        },
        {
          name: "firstname",
          value: name,
        },
        {
          name: "question",
          value: message,
        },
      ],
      context: {
        pageUri: "www.enviary.com",
        pageName: "Amjad Bukhari",
      },
    };

    var final_data = JSON.stringify(data);

    xhr.open("POST", url);
    // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        navigate(
          "https://enviary.com/thank-you-for-writing-us?utm_source=home-page-contact-us&utm_medium=Home%20Page%20Contact%20Us%20Button&utm_campaign=Enviary's%20Internal%20Clicks%20Tracking&utm_term=enviary&utm_content=contact-us"
        );
        setName("");
        setEmail("");
        setMessage("");
      } else if (xhr.readyState === 4 && xhr.status === 403) {
        alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.
      } else if (xhr.readyState === 4 && xhr.status === 404) {
        alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found
      }
    };

    // Sends the request
    xhr.send(final_data);
  };
  return (
    <div className="contactus" id="contactus">
      <div className="contactus__title">
        <h2>Get started with Klaviyo setup, optimisation and segmentation</h2>
        <hr />
      </div>

      <div className="contactus__content">
        <div className="contactus__content__left">
          <h5>connect with us</h5>

          <img src={require("../Img/contactLogo.png")} alt="Contact Logo" />
          <div className="contactusIcons">
            <img
              className="socialIcon"
              src={require("../Img/Facebook.png")}
              alt="Facebook"
              onClick={() =>
                openInNewTab("https://www.facebook.com/enviaryofficial")
              }
            />

            <img
              className="socialIcon"
              src={require("../Img/Linkedin.png")}
              alt="Linkedin"
              onClick={() =>
                openInNewTab("https://www.linkedin.com/company/enviary")
              }
            />

            <img
              className="socialIcon"
              src={require("../Img/Twitter.png")}
              alt="Twitter"
              onClick={() =>
                openInNewTab("https://twitter.com/enviaryofficial")
              }
            />
          </div>
          <div className="email">
            <img src={require("../Img/letter.png")} alt="Mail" />
            <p>support@enviary.com</p>
          </div>
        </div>

        <div className="contactus__content__right">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Your Name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
            />
            <input
              type="email"
              placeholder="Your Email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            <textarea
              name="comment"
              form="usrform"
              placeholder="Type your message here"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              required
            />

            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
